import { Box, useBreakpointValue, Stack, Center, Skeleton, SimpleGrid } from "@chakra-ui/react";
import React from "react";
import { useSkeletonProps, useUserPreference } from "hooks";
import { DEFAULT_SIDEBAR_WIDTH } from "screens/landing/components";
import { useSettingContext } from "screens/panels/settings/SettingsProvider";
import { APP_CONTAINER_WIDTH } from "screens/landing/Landing";

export const HomeSkeleton = () => {
  const skeletonStyle = useSkeletonProps();
  const maxProjectTiles = useBreakpointValue([1, 2, 3, 3, 3]);
  const maxNewsTiles = useBreakpointValue([1, 2, 2, 5, 5]);
  const maxStockTickers = useBreakpointValue([2, 2, 4, 5, 7]);
  const isMobile = useBreakpointValue({ base: true, md: false }, { fallback: "md", ssr: false });
  const isTablet = useBreakpointValue({ base: false, md: true, lg: false }, { fallback: "md", ssr: false });
  const showFullWidth = useUserPreference("ui_enable_view_full_width") as boolean;
  const sidebarWidth = (useUserPreference("ui_sidebar_width") as number) || (DEFAULT_SIDEBAR_WIDTH as number);
  const { isSideNavigationOpen } = useSettingContext();

  return (
    <Box
      height="100%"
      px={showFullWidth ? "1rem" : "0"}
      width={
        isMobile || isTablet || showFullWidth
          ? "100vw"
          : !isSideNavigationOpen
          ? `${APP_CONTAINER_WIDTH}px`
          : `calc(100vw - ${sidebarWidth}px)`
      }
      overflow="hidden">
      <Box width="100%">
        <Center>
          <Stack direction="row" justifyContent={"space-evenly"} spacing="1rem" width="100%" py={isTablet ? "1rem" : "2rem"}>
            <>
              {[...Array(maxStockTickers)].map((_, index) => (
                <Skeleton key={index} {...skeletonStyle} width={"100%"} height="2.5rem" />
              ))}
            </>
          </Stack>
        </Center>
      </Box>
      <Stack direction="row" justifyContent={"space-between"} spacing={isTablet ? "1rem" : "2rem"} height="100%">
        <Stack width={"100%"} spacing={isTablet ? "1rem" : "2rem"} height={"100%"}>
          <Box height="100%" width="100%">
            <Skeleton {...skeletonStyle} height="24rem" />
          </Box>
          <Box height="100%" width="100%">
            <SimpleGrid spacing="1rem" columns={1} py="1rem">
              <>
                {[...Array(maxProjectTiles)].map((_, index) => (
                  <Skeleton key={index} {...skeletonStyle} height="13rem" />
                ))}
              </>
            </SimpleGrid>
          </Box>
        </Stack>
        <Stack width="100%" spacing="2rem" height={"100%"}>
          <Box height="100%" width="100%">
            <Skeleton {...skeletonStyle} height="15rem" />
          </Box>
          <Box height="100%" width="100%">
            <Skeleton {...skeletonStyle} height="13rem" />
          </Box>
          <Box height="100%" width={"100%"} className="ch-home-recent-activity">
            <Stack spacing="1rem">
              {[...Array(maxNewsTiles)].map((_, index) => (
                <Stack key={index} direction="row" spacing="1rem">
                  <Skeleton {...skeletonStyle} width="10rem" height="5rem" borderRadius="md" />
                  <Stack width="100%" height={"100%"} justifyContent="space-between" pt="5px">
                    <Skeleton {...skeletonStyle} height=".8rem" />
                    <Skeleton {...skeletonStyle} height=".8rem" />
                    <Skeleton {...skeletonStyle} height=".5rem" width="5rem" mt=".5rem" />
                  </Stack>
                </Stack>
              ))}
            </Stack>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};
